// extracted by mini-css-extract-plugin
module.exports = {"contractstartingRoot":"contractstartingRoot--8419e","contractstartingProgress":"contractstartingProgress--1fe1c"};